// extracted by mini-css-extract-plugin
export var actionText = "_nc-4";
export var container = "_nc-0";
export var leftSection = "_nc-1";
export var rightSection = "_nc-2";
export var settingsButton = "_nc-6";
export var settingsIcon = "_nc-7";
export var shortcut = "_nc-5";
export var shortcutGroup = "_nc-3";